import { Injectable } from '@angular/core';
import { StorageKeys } from '../config/storage-keys';
import { LoginUser } from '../models';
import { SessionStorageService } from './session-storage.service';

@Injectable({
	providedIn: 'root',
})
export class LoginUserService {
	constructor(private readonly sessionStorageService: SessionStorageService) {}

	public get user(): LoginUser | null {
		return this.prepareLoginUserInfo();
	}

	public updateUser(user: unknown): void {
		this.sessionStorageService.setItem(StorageKeys.LOGGED_USER, JSON.stringify(user));
	}

	public isValidLogin(): boolean {
		try {
			const user = this.user;
			return !!(user?.id);
		} catch {
			return false;
		}
	}

	public getLogOutUser(): void {
		this.sessionStorageService.removeItem(StorageKeys.LOGGED_USER);
	}

	private prepareLoginUserInfo(): LoginUser | null {
		const login_user = this.sessionStorageService.getItem(StorageKeys.LOGGED_USER);
		if (login_user) {
			return JSON.parse(login_user);
		} else {
			return null;
		}
	}
}
